import { render, staticRenderFns } from "./MdmAppPage.vue?vue&type=template&id=022870fe&scoped=true&lang=pug&"
import script from "./MdmAppPage.vue?vue&type=script&lang=js&"
export * from "./MdmAppPage.vue?vue&type=script&lang=js&"
import style0 from "./MdmAppPage.vue?vue&type=style&index=0&id=022870fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022870fe",
  null
  
)

export default component.exports